import { useState } from "react"

import { ProgressBar } from "../../components/ProgressBar"
import RecommendationsLoader from "../../components/RecommendationsLoader"
import GovtWizardQuizForm from "./GovtWizardQuizForm"
import { GovtApWizardType } from "@/types/govtAppWizard"
import GovtWizardQuizCompleted from "./GovtWizardQuizCompleted"

interface GovtWizardContentQuizProps {
  govtAppWizard: GovtApWizardType | undefined
  handleNext: () => void
}

const GovtWizardContentQuiz = ({
  govtAppWizard,
  handleNext,
}: GovtWizardContentQuizProps) => {
  const [quizStep, setQuizStep] = useState<number>(0)
  const [completed, setCompleted] = useState<boolean>(false)
  const [showRecommendationsLoader, setShowRecommendationsLoader] =
    useState<boolean>(false)

  const imageUrl = Array.isArray(govtAppWizard?.questionnaire_attestations)
    ? govtAppWizard.questionnaire_attestations[quizStep]?.image_url
    : undefined

  const handleQuizStep = (newQuizStep: number) => {
    setQuizStep(newQuizStep)
  }

  const handleCompleted = (completed: boolean) => {
    setCompleted(completed)
  }

  const handleShowRecommendations = () => {
    setShowRecommendationsLoader(true)

    setTimeout(() => {
      setShowRecommendationsLoader(false)
      handleNext()
    }, 6500)
  }

  const questionnaireAttestations = govtAppWizard?.questionnaire_attestations
  const stepsLength =
    (questionnaireAttestations && questionnaireAttestations?.length) || 0

  return (
    <div data-testid="govt-wizard-content-quiz">
      <ProgressBar
        className="onboarding-survey-progress-bar w-full h-5"
        value={completed ? stepsLength + 1 : quizStep + 1}
        max={stepsLength + 2}
      />

      {showRecommendationsLoader ? (
        <RecommendationsLoader
          title="Your goal based stack options are being prepared! We just need to shuffle a few more options."
          steps={[
            "Reviewing your Goals",
            "Looking through Programs",
            "Matching Practices to goals",
            "Organizing stacks",
            "Creating recommendations",
          ]}
        />
      ) : completed ? (
        <GovtWizardQuizCompleted
          eligibleProgramType={govtAppWizard?.eligible_program_type}
          handleCompleted={handleCompleted}
          handleQuizStep={handleQuizStep}
          handleNext={handleShowRecommendations}
        />
      ) : (
        <GovtWizardQuizForm
          questionnaireAttestations={questionnaireAttestations}
          accountAttestations={govtAppWizard?.account_attestations}
          quizStep={quizStep}
          setQuizStep={handleQuizStep}
          setCompleted={handleCompleted}
          imageUrl={imageUrl}
        />
      )}
    </div>
  )
}

export default GovtWizardContentQuiz
